export default "__VITE_ASSET__JBF046ja__"